import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative w-full max-w-sm items-center" }
const _hoisted_2 = { class: "pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center px-2" }
const _hoisted_3 = {
  key: 1,
  class: "flex h-6 w-full items-center px-2"
}
const _hoisted_4 = { class: "truncate" }
const _hoisted_5 = { class: "absolute right-2 flex size-3.5 items-center justify-center" }
const _hoisted_6 = { class: "text-muted-foreground p-2 text-xs" }

import { ChevronDown, Check, Search } from 'lucide-vue-next';
    import {
        ComboboxAnchor,
        ComboboxContent,
        ComboboxInput,
        ComboboxItem,
        ComboboxItemIndicator,
        ComboboxLabel,
        ComboboxEmpty,
        ComboboxRoot,
        ComboboxTrigger,
        ComboboxViewport,
        ComboboxSeparator,
        ComboboxVirtualizer,
        useFilter,
    } from 'reka-ui';
    import { computed, ref, watch } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { Button } from '@/components/ui/button';
    import { usePage } from '@inertiajs/vue3';
    import { type SharedData } from '@/types';
    import { useForm } from '@inertiajs/vue3';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppCustomerSelector',
  setup(__props) {

    const { t } = useI18n();
    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const searchTerm = ref('');

    const form = useForm({
        selected_company_id: selectedCompanyId.value,
    });

    watch(selectedCompanyId, (newValue) => {
        form.selected_company_id = newValue;
    });

    const options = computed(() => page.props.auth?.companies);

    const { contains } = useFilter({ sensitivity: 'base' });

    const filteredOptions = computed(() => {
        const filtered = options.value.filter(
            (option) =>
                option.is_group ||
                option.is_seperator ||
                contains(option.label, searchTerm.value)
        );

        if(filtered[0].value === 'seperator-1') {
            filtered.shift();
        }

        return filtered;
    });

    const selectedOption = computed(() => {
        return options.value.find((opt) => opt.value === form.selected_company_id);
    });

    const getOptionLabel = computed(() => {
        if (!selectedOption.value || selectedOption.value.value === null)
            return t('companies.choose');
        return selectedOption.value.label;
    });

    const setSelectedCompany = () => {
        form.patch(route('v2.dashboard.selected.set'));
    };

    const open = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ComboboxRoot), {
    modelValue: _unref(form).selected_company_id,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).selected_company_id) = $event)),
      setSelectedCompany
    ],
    open: open.value,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((open).value = $event)),
    multiple: false
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(ComboboxTrigger), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "ghost_primary",
                size: "xs",
                width: "full",
                class: "normal-case"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getOptionLabel.value) + " ", 1),
                  _createVNode(_unref(ChevronDown), { class: "size-4 cursor-pointer" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(ComboboxContent), {
        position: "popper",
        align: "end",
        "side-offset": 4,
        class: "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-xs origin-(--reka-combobox-content-transform-origin) overflow-y-auto rounded-md border bg-white shadow-md will-change-[opacity,transform]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(ComboboxInput), {
              "display-value": () => '',
              modelValue: searchTerm.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
              class: "h-7.5 w-full rounded-none border-0 border-b pl-7.5 text-xs outline-none focus-visible:ring-0",
              placeholder: _unref(t)('forms.search')
            }, null, 8, ["modelValue", "placeholder"]),
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_unref(Search), { class: "text-faded-foreground size-3.5" })
            ])
          ]),
          _createVNode(_unref(ComboboxViewport), { class: "max-h-80 p-1" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ComboboxVirtualizer), {
                options: filteredOptions.value,
                "estimate-size": 24,
                "text-content": (opt) => opt.label
              }, {
                default: _withCtx(({ option }) => [
                  (option.is_group)
                    ? (_openBlock(), _createBlock(_unref(ComboboxLabel), {
                        key: option.label,
                        class: "text-foreground/50 mx-2 w-full px-0 py-1.5 text-xs leading-none"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option.label), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (option.is_seperator)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_openBlock(), _createBlock(_unref(ComboboxSeparator), {
                            class: "bg-border h-[1px] w-full",
                            key: `${option.value}`
                          }))
                        ]))
                      : (_openBlock(), _createBlock(_unref(ComboboxItem), {
                          value: option.value,
                          key: option.value || 'default',
                          class: "data-[state=checked]:text-primary text-foreground data-[disabled]:text-muted-foreground data-[highlighted]:bg-primary/10 relative flex w-full cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-2 pl-2 text-xs leading-none select-none data-[disabled]:pointer-events-none data-[highlighted]:outline-none data-[state=checked]:pr-8"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(option.label), 1),
                            _createElementVNode("span", _hoisted_5, [
                              _createVNode(_unref(ComboboxItemIndicator), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Check), { class: "text-primary size-3" })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                ]),
                _: 1
              }, 8, ["options", "text-content"]),
              _createVNode(_unref(ComboboxEmpty), null, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('forms.no_options')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "open"]))
}
}

})